import { PermissionType } from './types';

export const PermissionRules = {
  account_settings_view: 'Account Settings View',
  account_settings_manage: 'Account Settings Manage',
  benefit_manage: 'Benefit Manage',
  benefit_create: 'Benefit Create',
  benefit_delete: 'Benefit Delete',
  benefit_view: 'Benefit View',
  benefit_view_reports: 'Benefit View Reports',
  company_create: 'Company Create',
  company_manage: 'Company Manage',
  company_profile_edit: 'Company Profile Edit',
  company_profile_view: 'Company Profile View',
  company_profile_manage: 'Company Profile Manage',
  document_manage: 'Document Manage',
  company_view: 'Company View',
  call_group_view: 'Call Group View',
  call_group_manage: 'Call Group Manage',
  compliance_and_verification: 'Compliance and Verification',
  compliance_manage: 'Compliance Manage',
  compliance_and_verification_view: 'Compliance View',
  compliance_and_verification_manage: 'Compliance and Verification Manage',
  contact_create: 'Contact Create',
  contact_view: 'Contact View',
  individual_create: 'Individual Create',
  individual_view: 'Individual View',
  individual_manage: 'Individual Manage',
  marketing_campaign_create: 'Marketing Campaign Create',
  news_create: 'News Create',
  payment_view: 'Payment View',
  payment_manage: 'Payment Manage',
  pipeline_access: 'Pipeline Access',
  pipeline_manage: 'Pipeline Manage',
  pipeline_view: 'Pipeline View',
  policy_manage: 'Policy Manage',
  policy_view: 'Policy View',
  product_create: 'Product Create',
  product_delete: 'Product Delete',
  product_request: 'Product Request',
  product_view: 'Product View',
  product_manage: 'Product Manage',
  api_view: 'API View',
  reward_create: 'Reward Create',
  reward_delete: 'Reward Delete',
  reward_view: 'Reward View',
  role_create: 'Role Create',
  role_view: 'Role View',
  role_manage: 'Role Manage',
  subscription_manage: 'Subscription Manage',
  task_manage: 'Task Manage',
  task_view: 'Task View',
  team_create: 'Team Create',
  team_view: 'Team View',
  team_manage: 'Team Manage',
  business_function_manage: 'Business Function Manage',
  news_view: 'News View',
  news_manage: 'News Manage',
  integration_view: 'Integration View',
  loyalty_rewards: 'Loyalty & Rewards',
  quote_view: 'Quote View',
  quote_manage: 'Quote Manage',
  quote_delete: 'Quote Delete',
  invoice_view: 'Invoice View',
  invoice_manage: 'Invoice Manage',
  invoice_delete: 'Invoice Delete',
  terminal_view: 'Terminal View',
  terminal_manage: 'Terminal Manage',
  terminal_request: 'Terminal Request',
  xero_invoices_view: 'Xero Invoice View',
  xero_invoices_manage: 'Xero Invoice Manage',
  savings_view: 'Savings View',
  savings_manage: 'Savings Manage',
  direct_billing_manage: 'Savings Direct Billing Manage',
  savings_delete: 'Savings Delete',
  savings_leap_year_manage: 'Savings Leap Year Manage',
  savings_product_frequency_manage: 'Savings Product Frequency Manage',
  // The API's permission name; generating and deleting bank instruction files.
  savings_instruction_file_manage: 'Akoni Instruction File Manage',
  platform_policy_manage: 'Platform Policy Manage',
  off_platform_policy_view: 'Off Platform Policy View',
  off_platform_policy_manage: 'Off Platform Policy Manage',
  off_platform_policy_delete: 'Off Platform Policy Delete',
  document_template_view: 'Document Template View',
  document_template_manage: 'Document Template Manage',
  team_events_view: 'View Team Events',
  events_view: 'View All Events',
  events_manage: 'Events Manage',
  view_team_targets: 'View Team Targets',
  view_pipeline_targets: 'View Pipeline Targets',
  provider_manage: 'Provider Manage',
  chat_with_data: 'Chat with data',
  list_manage: 'List Manage',
  list_view: 'List View',
  aggregated_business_unit_revenue_view:
    'Aggregated Business Unit Revenue View',
  services_other_products_manage: 'Services Other Products Manage',
  fee_structure_manage: 'Fee Structure Manage',
  sub_product_manage: 'Sub Product Manage',
  objective_view: 'Objectives View',
  objective_manage: 'Objectives Manage',
  objective_admin: 'Objectives Admin',
  relationship_tags_manage: 'Relationship Tags Manage',
  sentiment_config_view: 'Sentiment Config View',
  sentiment_config_manage: 'Sentiment Config Manage',
  meeting_view: 'Meeting View',
  meetings_view: 'Meetings View'
};

export const allowAllPermissions = Object.keys(
  PermissionRules
) as PermissionType[];
